export default __webpack_public_path__ + "static/media/Donation.e22e507d.png";